import React from "react"
import { CaseStudyTemplate } from "./CaseStudyTemplate"

export default function AuroraCollectionCaseStudy() {
  return (
    <CaseStudyTemplate
      backToAnchorId="selected-work-aurora-collection"
      eyebrow="Selected work"
      tag="Brand Identity"
      title="Aurora Collection — Luxury Wordmark"
      summary="A refined identity direction built around bespoke serif lettering and a signature central mark—paired with a restrained sans-serif subline for a premium, editorial-ready brand lockup."
      image="/Auroa.jpg"
      imageAlt="Aurora Collection logo mockup on textured paper with natural light"
      sections={[
        {
          title: "The brief",
          body: "Develop a high-end fashion or lifestyle feel: memorable typography, strong contrast, and a mark that can anchor packaging, tags, and digital without feeling busy.",
        },
        {
          title: "The system",
          body: "Primary logotype emphasis on “AURORA” with a custom decorative centerpiece, supported by spaced “COLLECTION” typography—black on light texture for timeless contrast.",
        },
        {
          title: "Outcome",
          body: "A confident, scalable wordmark that reads luxury in still mockups and can extend cleanly across print and screen.",
        },
      ]}
      tech={["Adobe Illustrator", "Adobe Photoshop", "Typography", "Brand Mockups"]}
      results={[
        "Custom lettering direction",
        "Editorial mockup presentation",
        "Premium contrast & spacing",
        "Retail-ready lockup",
      ]}
    />
  )
}
